
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Corporatevents() {



    const cardData =
    {
        keyword: 'Corporate Events Bus On Rent in Pune',
        heading: 'Amruta Travels: Corporate Events Bus On Rent in Pune',
        headingDescription: 'Amruta Travels offers Corporate Events Bus on Rent in Pune, designed to provide seamless and comfortable group transportation for business meetings, seminars, team outings, conferences, and corporate gatherings. Our fleet of well-maintained AC and non-AC buses ensures professional-grade service with clean interiors, ample seating, and smooth rides. With punctual scheduling, courteous drivers, and 24/7 customer support, Amruta Travels makes your corporate event logistics efficient and worry-free.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',


  "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Located around 120 km from Pune, Mahabaleshwar is a picturesque hill station in the Western Ghats, known for its cool climate, evergreen forests, and stunning viewpoints such as Arthur’s Seat, Wilson Point (the highest point), and Kate's Point. The region is famous for its strawberry farms, especially during the Strawberry Festival held in spring. Other attractions include Venna Lake for boating, Mapro Garden for strawberry-based treats, and ancient temples like Panchganga and Mahabaleshwar Temple. It's a popular destination for families, honeymooners, and nature enthusiasts seeking a refreshing escape from city life."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range offer a perfect blend of natural beauty and adventure. Lonavala is known for its misty mountains, lush greenery, and monsoon waterfalls like Kune and Bhivpuri. Attractions include Bhushi Dam, Tiger’s Leap, Rajmachi Fort, and Karla & Bhaja Caves. Khandala is equally famous for its panoramic valley views and trekking routes. The area is ideal for a weekend drive, with scenic routes and roadside chikki stalls that add to the charm of this quick getaway."
    },
    {
      "title": "Shirdi",
      "description": "About 190 km from Pune, Shirdi is a sacred town revered by followers of Sai Baba. The Sai Baba Samadhi Mandir is the main attraction, drawing millions of devotees every year. Pilgrims can also visit Dwarkamai, Chavadi, and the Sai Heritage Village. The spiritual ambiance, combined with well-maintained infrastructure and religious events, makes Shirdi a prominent destination for those seeking peace, healing, and spiritual growth."
    },
    {
      "title": "Goa",
      "description": "Located nearly 450 km from Pune, Goa is India’s premier beach destination, known for its lively culture, golden beaches, and Portuguese heritage. From North Goa’s party hotspots like Baga, Anjuna, and Calangute to South Goa’s serene stretches like Palolem and Colva, there’s a vibe for every traveler. Apart from beaches, visitors can explore Aguada Fort, Basilica of Bom Jesus, spice plantations, vibrant flea markets, and indulge in thrilling water sports. Goa is also a haven for foodies, offering authentic seafood, Goan curries, and beachside shacks serving refreshing cocktails."
    },
    {
      "title": "Nashik",
      "description": "Around 210 km from Pune, Nashik is a city of immense cultural, historical, and spiritual significance. It is one of the four cities where the Kumbh Mela is held. Attractions include the ancient Kalaram Temple, Muktidham Temple, Pandavleni Caves, and Trimbakeshwar Temple—an important Jyotirlinga. Nashik is also the wine capital of India, home to Sula Vineyards, York Winery, and many tasting tours. The Godavari River adds to its charm, making it a harmonious blend of spirituality and leisure tourism."
    },
    {
      "title": "Alibaug",
      "description": "Situated about 140 km from Pune, Alibaug is a tranquil coastal town offering a perfect mix of beaches, history, and nature. Popular beaches include Nagaon, Alibaug Beach, and Kashid Beach, all great for swimming, sunbathing, and water sports. The iconic Kolaba Fort, accessible during low tide, adds historical value to the destination. You can also explore Korlai Fort, Kanakeshwar Temple, and local seafood cuisine. Ideal for weekend trips, Alibaug also offers ferry services from Mumbai for added convenience."
    },
    {
      "title": "Kolhapur",
      "description": "Roughly 235 km from Pune, Kolhapur is a vibrant city known for its divine Mahalaxmi Temple, which draws pilgrims throughout the year. The city is equally famous for its spicy cuisine, Kolhapuri chappals, and traditional arts. Attractions include Rankala Lake for evening strolls, Panhala Fort offering panoramic views, and the New Palace Museum showcasing royal heritage. With its rich cultural identity and warm hospitality, Kolhapur is ideal for heritage and culinary tourism."
    },
    {
      "title": "Lavasa",
      "description": "Just 60 km from Pune, Lavasa is an Italian-inspired planned city nestled in the Sahyadri hills. It features beautiful waterfronts, European-style architecture, and a peaceful atmosphere perfect for a quick weekend escape. Activities include kayaking, zip-lining, and lakeside cycling. With cozy resorts, conference centers, and nature trails, Lavasa attracts both families and corporate travelers. The weather remains pleasant most of the year, enhancing its appeal as a rejuvenating destination close to Pune."
    },
    {
      "title": "Satara & Kaas Plateau",
      "description": "About 120 km from Pune, Satara serves as the base for exploring the Kaas Plateau—popularly known as the 'Valley of Flowers' of Maharashtra. The plateau, a UNESCO World Natural Heritage site, bursts into a riot of colors with over 850 species of wildflowers during the monsoon season. Satara is also known for Ajinkyatara Fort, Thoseghar Waterfalls, and Sajjangad Fort. The natural beauty and biodiversity make this region a paradise for trekkers, botanists, and photographers."
    },
    {
      "title": "Aurangabad",
      "description": "Situated 235 km from Pune, Aurangabad is a historical treasure trove, offering insights into ancient art, architecture, and culture. The city is home to the world-famous Ajanta and Ellora Caves, adorned with exquisite carvings and paintings dating back to 2nd century BCE. Other attractions include Bibi Ka Maqbara (a replica of the Taj Mahal), Daulatabad Fort, and Aurangabad Caves. The city is also a gateway to Grishneshwar Jyotirlinga and Paithani saree shopping, making it a must-visit for heritage lovers."
    }
  ],

  "services": [
    {
      "name": "Bus Hire for Corporate Events Pune",
      "description": "Our Bus Hire for Corporate Events in Pune provides comfortable and reliable transportation for your corporate gatherings. Whether it's a seminar, meeting, or conference, we ensure punctuality and comfort for all attendees."
    },
    {
      "name": "25 to 50 Seater Bus Rental Corporate",
      "description": "We offer a range of bus rental options for corporate events, from 25-seater to 50-seater buses, providing flexibility to suit your group size. Our buses are well-maintained and equipped with AC, ensuring comfort for all your employees or guests."
    },
    {
      "name": "AC Bus for Corporate Party Pune",
      "description": "For corporate parties or celebrations, our AC buses offer a luxurious and comfortable travel experience. We can provide the ideal transport for your team to and from the event venue, making the trip enjoyable and relaxing."
    },
    {
      "name": "Bharat Benz/Volvo for Corporate Events",
      "description": "For a premium corporate experience, choose our **Bharat Benz** or **Volvo** buses. These buses are equipped with advanced amenities and are perfect for corporate events that require comfort and elegance during travel."
    },
    {
      "name": "Pune Corporate Seminar Bus",
      "description": "We provide buses for corporate seminars, ensuring timely and efficient transportation for your attendees. Our buses are well-equipped with comfortable seating and air conditioning to guarantee a smooth journey for everyone involved."
    },
    {
      "name": "Office Function Bus Hire",
      "description": "For office functions and gatherings, we offer convenient bus rental services. Our buses ensure that all employees or guests reach the event venue on time, making your office function hassle-free and enjoyable."
    },
    {
      "name": "Team Outing Bus Pune",
      "description": "Organizing a team outing? Our buses are the perfect way to transport your team. We offer customized routes and schedules, with buses that provide comfort and style for a memorable outing experience."
    },
    {
      "name": "Business Trip Bus Rental",
      "description": "Traveling for business? Our Business Trip Bus Rental service is perfect for corporate teams traveling together. We offer buses that ensure comfortable travel, equipped with all necessary amenities for your corporate trip."
    },
    {
      "name": "Conference Transport Bus Hire",
      "description": "For conferences, our conference transport bus hire service provides comfortable and timely transportation for all participants. We accommodate different group sizes with our fleet, ensuring a smooth travel experience."
    },
    {
      "name": "Employee Team Building Bus",
      "description": "Our Employee Team Building Bus service is designed for corporate team-building activities. We ensure that your team travels together in a comfortable and relaxed environment, fostering unity and collaboration even before the event begins."
    },
    {
      "name": "Executive Party Bus Pune",
      "description": "For executive parties and VIP events, our Executive Party Bus offers luxury and comfort. Choose from our fleet of premium buses, including Volvo and Bharat Benz, to ensure your corporate executives travel in style."
    },
    {
      "name": "Large Corporate Event Bus",
      "description": "For large corporate events, we offer spacious buses that can accommodate a large number of attendees. We ensure smooth transportation to and from the event venues, with buses equipped with modern amenities to ensure comfort."
    },
    {
      "name": "AC Coach for Corporate Trips",
      "description": "For corporate trips, we offer AC coaches that provide superior comfort. These coaches are perfect for off-site meetings, conferences, or team retreats, ensuring that your team arrives at the destination refreshed and ready."
    },
    {
      "name": "Corporate Weekend Getaway Bus",
      "description": "Our Corporate Weekend Getaway Bus services are ideal for company retreats or weekend getaways. We ensure a comfortable and relaxed journey for your employees, allowing them to unwind during their corporate trip."
    },
    {
      "name": "Corporate Award Ceremony Transport",
      "description": "For your corporate award ceremonies, we provide transportation that ensures all your guests arrive on time and in comfort. Our buses are ideal for transporting employees, clients, or award winners to and from the ceremony venue."
    }
  ],
  "tableData": [
    ["Bus Hire for Corporate Events Pune", "25 to 50 Seater Bus Rental Corporate"],
    ["AC Bus for Corporate Party Pune", "Bharat Benz/Volvo for Corporate Events"],
    ["Pune Corporate Seminar Bus", "Office Function Bus Hire"],
    ["Team Outing Bus Pune", "Business Trip Bus Rental"],
    ["Conference Transport Bus Hire", "Employee Team Building Bus"],
    ["Executive Party Bus Pune", "Large Corporate Event Bus"],
    ["AC Coach for Corporate Trips", "Corporate Weekend Getaway Bus"],
    ["Corporate Award Ceremony Transport"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Corporate Events Bus on Rent in Pune",
    "WhyChoosedescription": "Amruta Travels offers professional and reliable bus rentals for corporate events in Pune. Whether you're planning a team-building activity, seminar, conference, or company outing, our buses provide a comfortable, efficient, and stylish solution for transporting your team to and from the event."
  },
  {
    "WhyChooseheading": "Comfortable, Air-Conditioned Travel for Corporate Teams",
    "WhyChoosedescription": "Our buses are equipped with air-conditioning, spacious seating, and ample legroom, ensuring that your employees travel in comfort. Whether it's a short ride to a local event or a longer journey to an out-of-town conference, our buses provide a relaxing and productive environment for your team."
  },
  {
    "WhyChooseheading": "Perfect for Team Outings, Conferences, and Seminars",
    "WhyChoosedescription": "Amruta Travels’ buses are ideal for transporting corporate groups to a variety of events, including conferences, seminars, corporate team outings, workshops, and more. Our buses accommodate both small and large groups, providing an organized, efficient, and enjoyable experience for all passengers."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe and Timely Travel",
    "WhyChoosedescription": "Our drivers are licensed, experienced, and trained to handle corporate travel with professionalism. They ensure safe, timely, and smooth transport, while maintaining the highest standards of courtesy and professionalism, so your team can focus on the event ahead."
  },
  {
    "WhyChooseheading": "Flexible Bus Rental Options to Suit Your Needs",
    "WhyChoosedescription": "We offer flexible bus rental solutions to accommodate your unique needs. From customized pick-up and drop-off locations to varying bus sizes, we can tailor our services to fit your schedule and requirements for corporate events, ensuring smooth logistics for your team."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing for Corporate Transport",
    "WhyChoosedescription": "Amruta Travels offers competitive and transparent pricing for corporate event bus rentals. Our rates include fuel, tolls, driver allowances, taxes, and more—eliminating any hidden charges and making it easy for you to plan and manage your budget."
  },
  {
    "WhyChooseheading": "Well-Maintained Fleet for a Safe and Comfortable Journey",
    "WhyChoosedescription": "Our fleet of buses is regularly serviced, inspected, and maintained to ensure a safe and smooth journey for your corporate group. With Amruta Travels, you can be confident that your transportation will be reliable and comfortable every time."
  },
  {
    "WhyChooseheading": "Simple Booking and 24/7 Customer Support",
    "WhyChoosedescription": "Booking your corporate event bus with Amruta Travels is easy and convenient. You can reserve a bus online, over the phone, or at our office. Our 24/7 customer support team is available to assist with bookings, itinerary changes, and any other travel-related inquiries."
  }
]























    }

const faqData = [
  {
    question: 'Can I hire a bus for corporate events in Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers buses on rent for corporate events in Pune. Whether you are organizing a conference, team-building event, corporate outing, or any other business-related event, we provide comfortable and reliable transport for your employees and guests.',
  },
  {
    question: 'What amenities are available in the corporate event buses?',
    answer: 'Our corporate event buses are equipped with comfortable seating, air conditioning, Wi-Fi (optional), USB charging ports, entertainment systems, ample legroom, and clean interiors to ensure a productive and comfortable journey for your team.',
  },
  {
    question: 'Are the buses for corporate events available for both local and outstation travel?',
    answer: 'Yes, our buses are available for both local city travel in Pune as well as outstation trips for corporate events to various destinations in Maharashtra and beyond.',
  },
  {
    question: 'Is a driver included in the corporate event bus rental?',
    answer: 'Yes, all our corporate event bus rentals include a professional and licensed driver who ensures a safe, timely, and comfortable journey for your group. The driver is trained to meet corporate travel standards.',
  },
  {
    question: 'How much does it cost to hire a bus for corporate events in Pune?',
    answer: 'The cost of hiring a bus for corporate events in Pune depends on factors such as the type of bus, distance, duration, and specific services required. Typically, rates start from ₹30–₹45 per km. For a precise quote, contact us with your itinerary.',
  },
  {
    question: 'Are the buses for corporate events well-maintained and sanitized?',
    answer: 'Absolutely. All our buses are regularly maintained, thoroughly cleaned, and sanitized before each trip to ensure hygiene, safety, and comfort for all passengers.',
  },
  {
    question: 'How do I book a bus for corporate events in Pune?',
    answer: 'You can easily book a bus for corporate events online through our website or by contacting our customer support team. We offer quick booking assistance and tailor our services to meet the specific needs of your corporate event.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Sandeep Joshi',
    role: 'Corporate Event Manager, Pune',
    text: 'We hired a bus from Amruta Travels for a corporate outing. The bus was comfortable, and the amenities were perfect for our team. The driver was professional, and the service was seamless from start to finish. Highly recommend for corporate events!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Mehta',
    role: 'HR Head, Pune',
    text: 'I booked a bus from Amruta Travels for a corporate team-building event. The bus was punctual, well-maintained, and equipped with everything we needed for a comfortable journey. The service exceeded our expectations. We will definitely consider Amruta Travels for future events!',
    rating: 5,
  },
];






























































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Events Bus On Rent in Pune",
  "image": "https://bushireinpune.com/assets/images/corporate-events-bus-rent-pune.jpg",
  "description": "Amruta Travels provides Corporate Events Bus on Rent in Pune, offering 25 to 50-seater AC buses for corporate parties, team outings, business trips, seminars, conferences, and more. Choose from luxury buses including Bharat Benz and Volvo for your corporate transport needs. Affordable and reliable transportation for large corporate events, office functions, and weekend getaways.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "1900"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "18000",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/corporate-events-bus-rent-pune"
  }
};








    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Corporate Events Bus On Rent in Pune | Bus Hire for Team Outings & Conferences</title>
  <meta 
    name="description" 
    content="Rent an AC bus for corporate events in Pune. Hire 25 to 50-seater buses for seminars, conferences, team outings, business trips, corporate parties, and weekend getaways. Luxury transport with Bharat Benz/Volvo buses." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/2.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatevents;